import { render, staticRenderFns } from "./OrnamentHistory2.vue?vue&type=template&id=17a85168&scoped=true&"
import script from "./OrnamentHistory2.vue?vue&type=script&lang=js&"
export * from "./OrnamentHistory2.vue?vue&type=script&lang=js&"
import style0 from "./OrnamentHistory2.vue?vue&type=style&index=0&id=17a85168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a85168",
  null
  
)

export default component.exports